module.exports = __webpack_public_path__ + "static/media/sfv-sprites.87a56423.png";